// Re-export all types from agents module for targetsv2
export type {
  MonthlySummary,
  TargetInteface,
  TargetFull,
  TargetUser,
  QuarterInfo,
  Adjustment,
  ExtraAchievement,
  CalculatedUserData,
  TreeNode,
  TransformState,
  TreeBounds,
  OpenState,
  RowProps,
} from "@/modules/agents/types";

import { UserType, TargetUserDTO } from "@/modules/agents/dtos/index.v2";

// Add interface for sales data
export interface targetsData {
  period: string;
  current: string;
  target: string;
  percentage: number;
  effectiveTargetType?: string;
  /**
   * Distinguishes whether the row represents a team-level target or a personal-level target.
   * When undefined, "team" is assumed for backwards compatibility.
   */
  targetType?: "team" | "personal";
  extraAchievement?: number;
  userType?: UserType;
}

// Enum for effective target types
export enum EffectiveTargetType {
  MULTIPLIER = "multiplier",
  MINIMUM = "minimum",
  ACTUAL = "actual",
  NORMAL = "normal",
}

// Color mapping for effective target types
export const getEffectiveTargetTypeColor = (type: string): string => {
  switch (type.toLowerCase()) {
    case EffectiveTargetType.MULTIPLIER:
      return "#0891B2"; // Current cyan color (theme.nawy.colors.semantic.text.accent)
    case EffectiveTargetType.MINIMUM:
      return "#A74E9E"; // Magenta 600
    case EffectiveTargetType.ACTUAL:
      return "#3E8D7B"; // Green 700
    case EffectiveTargetType.NORMAL:
      return "#0891B2"; // Same as multiplier color
    default:
      return "#0891B2"; // Default to multiplier color
  }
};

export interface ConnectorPosition {
  position: number;
  username: string;
  hasChildren?: boolean;
  children?: ConnectorPosition[];
  targetsData?: targetsData[];
}

export interface AvatarWithConnectorsProps {
  username: string;
  connectors?: ConnectorPosition[];
  hasReports?: boolean;
  cognitoId?: string;
  color?: string;
  startDate?: string;
  endDate?: string;
  onThreadHeightChange?: (height: number, cognitoId: string) => void;
  targetsData?: targetsData[];

  user?: TargetUserDTO;
  quarter?: 1 | 2 | 3 | 4;
  year?: number;
}

export interface ThreadConnectorProps {
  top: number;
  username: string;
  hasChildren?: boolean;
  children?: ConnectorPosition[];
  isExpanded?: boolean;
  onExpandClick?: () => void;
  expandedStates: Record<string, boolean>;
  onChildExpandClick: (username: string) => void;
  parentHovered?: boolean;
  hoveredStates: Record<string, boolean>;
  onMouseEnter: (username: string, isParent?: boolean) => void;
  onMouseLeave: (username: string) => void;
  isLoading?: boolean;
  loadingNodes?: Set<string>;
  nodeCognitoIds?: Map<string, string>;
  targetsData?: targetsData[];
  userType?: UserType;
  user?: TargetUserDTO;
  quarter?: 1 | 2 | 3 | 4;
  year?: number;
}
